import { formatCurrency } from "../../../../../utils/currency";
import { formatQuantity } from "../../../../../utils/numbers";
import { ColumnsType } from "antd/es/table";
import { ExpenseDescriptionDetail } from "@/types/report";
import { ColumnsProps } from "@/components/table";

export const getColumns = ({
  record,
  filterOptions,
  filterValues,
  getSortOrder,
}: ColumnsProps<ExpenseDescriptionDetail>): ColumnsType<ExpenseDescriptionDetail> => [
  {
    title: "Description",
    dataIndex: ["description", "name"],
    key: "description_id",
    sorter: true,
    sortOrder: getSortOrder?.("description.name"),
    filterSearch: true,
    filters: filterOptions?.description_id,
    filteredValue: filterValues?.description_id || null,
  },
  {
    title: "Total",
    dataIndex: "total_amount",
    key: "total_amount",
    align: "right",
    render: (price: number) => formatCurrency(price),
    sorter: true,
    sortOrder: getSortOrder?.("total_amount"),
  },
  {
    title: "Total Quantity",
    dataIndex: "quantity",
    key: "quantity",
    align: "right",
    hidden: !record?.some((item) => item.quantity) && !filterValues?.quantity,
    sorter: true,
    sortOrder: getSortOrder?.("quantity"),
    render: (quantity: number) =>
      quantity ? formatQuantity(quantity, 2) : "-",
  },
  {
    title: "Average",
    dataIndex: "average",
    key: "average",
    align: "right",
    hidden: !record?.some((item) => item.average) && !filterValues?.average,
    sorter: true,
    sortOrder: getSortOrder?.("average"),
    render: (average: number) => formatCurrency(average),
  },
  {
    title: "Unit",
    dataIndex: ["unit", "name"],
    key: "unit_id",
    hidden: !record?.some((item) => item.unit) && !filterValues?.unit_id,
    sorter: true,
    sortOrder: getSortOrder?.("unit.name"),
    filterSearch: true,
    filters: filterOptions?.unit_id,
    filteredValue: filterValues?.unit_id || null,
    render: (name: string) => name || "-",
  },
];
